import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, createSlots as _createSlots, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = { class: "flex-1" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-space-between"
}
const _hoisted_4 = ["title"]
const _hoisted_5 = ["title"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 1,
  class: "d-flex justify-space-between align-center"
}
const _hoisted_8 = ["title"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["title"]
const _hoisted_11 = { key: 1 }

import { withDefaults, ref, onMounted, watch } from 'vue';
import { AtomSubTitle, AtomTitle } from '@/components/atoms';
import { formatPercentage } from '@/utils/formatNumber';

interface IProps {
  height: string;
  max?: number;
  hasPercent?: boolean;
  hasPercentTitle?: boolean;
  hasTitle?: boolean;
  margin1?: boolean;
  title?: string;
  progressColor?: string;
  colorPercent?: string;
  modelValue?: any;
  isTextBottom?: boolean,
  showPercentText?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomProgressBar',
  props: {
    height: { default: '10' },
    max: {},
    hasPercent: { type: Boolean, default: true },
    hasPercentTitle: { type: Boolean },
    hasTitle: { type: Boolean, default: false },
    margin1: { type: Boolean },
    title: {},
    progressColor: {},
    colorPercent: {},
    modelValue: {},
    isTextBottom: { type: Boolean },
    showPercentText: { type: Boolean, default: true }
  },
  setup(__props: any) {

function formatLang(value: number): string {
  return new Intl.NumberFormat('pt-BR').format(value);
}
// const emit = defineEmits<{
//   (e: 'update:modelValue', value: string | number | null): void;
// }>();
const props = __props;
const progress = ref(0);
onMounted(() => {
  progress.value = props.modelValue;
});

watch(
  () => props.modelValue,
  () => {
    progress.value = props.modelValue;
  }
);
onMounted(() => {
  progress.value = props.modelValue;
});

return (_ctx: any,_cache: any) => {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (props.hasTitle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_unref(AtomTitle), {
              "no-margin": "",
              title: props.title ?? '',
              classes: ['text-sm']
            }, null, 8, ["title"]),
            (props.hasTitle)
              ? (_openBlock(), _createBlock(_unref(AtomSubTitle), {
                  key: 0,
                  noMargin: "",
                  text: props.hasPercentTitle ? `${formatLang(progress.value)}%` : formatLang(progress.value) ?? ''
                }, null, 8, ["text"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("span", {
        title: 'O progresso atual é: ' + _unref(formatPercentage)(Number(progress.value))
      }, [
        _withDirectives((_openBlock(), _createBlock(_component_v_progress_linear, {
          color: _ctx.progressColor,
          class: _normalizeClass(["flex-1 w-100", { 'my-2': props.margin1, 'my-4': !props.margin1 }]),
          modelValue: progress.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((progress).value = $event)),
          height: _ctx.height,
          max: props.max ?? 100,
          rounded: "",
          style: {"min-width":"94px","height":"15px"}
        }, _createSlots({ _: 2 }, [
          (!_ctx.hasPercent)
            ? {
                name: "default",
                fn: _withCtx(({ value }) => [
                  _createElementVNode("strong", {
                    style: _normalizeStyle(`font-size: 10px; color: ${value <= 50 ? 'black' : 'white'};`)
                  }, [
                    (Number(value) > 100)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          title: _unref(formatPercentage)(Number(value))
                        }, "↑ 100,00%", 8, _hoisted_5))
                      : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(formatPercentage)(Number(value))), 1))
                  ], 4)
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["color", "class", "modelValue", "height", "max"])), [
          [_directive_tooltip, '952416758,00%']
        ])
      ], 8, _hoisted_4),
      (props.isTextBottom && props.showPercentText)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("p", {
              style: _normalizeStyle({ color: props.colorPercent }),
              class: "text-xs font-500"
            }, _toDisplayString(_ctx.title), 5),
            (props.hasPercent)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  style: _normalizeStyle({ color: props.colorPercent }),
                  class: "ms-4 text-xs font-500 text-gray-950"
                }, [
                  (Number(progress.value) > 100)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        title: 'O progresso atual é: ' + _unref(formatPercentage)(Number(progress.value))
                      }, "↑100,00%", 8, _hoisted_8))
                    : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(formatPercentage)(Number(progress.value))), 1))
                ], 4))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (props.hasPercent && !props.isTextBottom && props.showPercentText)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          style: _normalizeStyle({ color: props.colorPercent }),
          class: "ms-4 text-xs font-500 text-gray-950"
        }, [
          (Number(progress.value) > 100)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                title: 'O progresso atual é: ' + _unref(formatPercentage)(Number(progress.value))
              }, "↑100,00%", 8, _hoisted_10))
            : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(formatPercentage)(Number(progress.value))), 1))
        ], 4))
      : _createCommentVNode("", true)
  ]))
}
}

})